import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {
    connectStateResults,
    connectCurrentRefinements
} from "react-instantsearch-dom";
import Hits from "~/scripts/components/products/Hits";
import CurrentRefinements from "~/scripts/components/products/CurrentRefinements";
import Clear from "~/scripts/components/products/Clear";
import Query from "~/scripts/components/products/Query";
import NoResults from "~/scripts/components/products/NoResults";
import Searching from "~/scripts/components/products/Searching";
import ProductCard from "~/scripts/components/products/ProductCard";

const itemPropTypes = PropTypes.arrayOf(
    PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.func.isRequired,
        items: (...args) => itemPropTypes(...args)
    })
);

class ProductsGrid extends Component {
    static propTypes = {
        searchState: PropTypes.object,
        searching: PropTypes.bool.isRequired,
        searchResults: PropTypes.shape({
            nbHits: PropTypes.number
        }),
        items: itemPropTypes
    };

    brandRefinement = () => {
        const { items } = this.props;
        if (items.length !== 1) {
            return null;
        }

        const item = items[0];

        if (
            item.attribute === "family.brand" &&
            item.currentRefinement.length === 1
        ) {
            const brandTitle = item.currentRefinement[0];

            return window.brands.find(item => {
                return item.title === brandTitle;
            });
        }
    };

    getListType = ({ hierarchicalMenu, range, refinementList, query }) => {
        if (query) {
            return "Search";
        }

        let categoryFilterApplied = false;
        let otherFilterApplied = false;

        if (hierarchicalMenu) {
            if (hierarchicalMenu["family.categories.lvl0"].length > 0) {
                categoryFilterApplied = true;
            }
        }

        if (refinementList) {
            for (let attribute in refinementList) {
                if (refinementList[attribute].length > 0) {
                    otherFilterApplied = true;
                }
            }
        }

        if (range && range.lumens) {
            const { min, max } = range.lumens;

            if (min || max) {
                otherFilterApplied = true;
            }
        }

        if (categoryFilterApplied && otherFilterApplied) {
            return "Category + Filter";
        }

        if (categoryFilterApplied) {
            return "Category";
        }

        if (otherFilterApplied) {
            return "Filter";
        }

        return "Index";
    };

    render() {
        const { searching, searchResults, searchState, items } = this.props;
        const listType = this.getListType(searchState);
        const { page, ...params } = searchState;

        const hash = JSON.stringify(params);

        return (
            <div className="products-grid">
                <div
                    className={classNames("products-grid__refs", {
                        "has-items": items.length || searchState.query
                    })}
                >
                    <div className="products-grid__ref-items">
                        <CurrentRefinements />
                        <Query />
                    </div>
                    <div className="products-grid__clear">
                        <Clear linkText="Clear Filters" />
                    </div>
                </div>
                {searchResults &&
                    (searchResults.nbHits !== 0 ? (
                        <Hits
                            key={hash}
                            hitComponent={ProductCard}
                            brand={this.brandRefinement()}
                            listType={listType}
                        />
                    ) : (
                        <NoResults />
                    ))}
                {searching && <Searching theme="dark" />}
            </div>
        );
    }
}

export default connectCurrentRefinements(connectStateResults(ProductsGrid));



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/ProductsGrid.js